import type { ReactNode } from 'react';
interface CommentProps {
  author?: ReactNode;
  avatar?: ReactNode;
  content?: ReactNode;
  datetime?: ReactNode;
  actions?: ReactNode[];
  children?: ReactNode;
}
const Comment = ({
  author,
  avatar,
  content,
  datetime,
  actions,
  children
}: CommentProps) => <div style={{
  display: 'flex',
  gap: 12,
  padding: '8px 0'
}}>
		{avatar && <div style={{
    flexShrink: 0
  }}>{avatar}</div>}
		<div style={{
    flex: 1
  }}>
			<div style={{
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      marginBottom: 4
    }}>
				{author && <span style={{
        fontWeight: 600
      }}>{author}</span>}
				{datetime && <span style={{
        color: '#999',
        fontSize: 12
      }}>{datetime}</span>}
			</div>
			{content && <div suppressHydrationWarning>{content}</div>}
			{actions && <div style={{
      display: 'flex',
      gap: 8,
      marginTop: 4
    }} suppressHydrationWarning>
				{actions.map((action, i) => <span key={i}>{action}</span>)}
			</div>}
			{children}
		</div>
	</div>;
export default Comment;